import { twoPlans, threePlans, fourPlans, sixPlans } from './options.js'

export const STEPS = [
  { id: 1, title: 'Student Info' },
  { id: 2, title: 'School Info' },
  { id: 3, title: 'Attendance' },
  { id: 4, title: 'Learning Skills' },
  { id: 5, title: 'Subject Grades' },
  { id: 6, title: 'Arts & Comments' },
]

export const STEP_FIELDS = {
  1: ['studentName', 'oen', 'date', 'grade', 'teacher'],
  2: ['board', 'school', 'address1', 'address2', 'principal', 'telephone'],
  3: ['daysAbsent', 'totalDaysAbsent', 'timesLate', 'totalTimesLate', 'boardInformation1'],
  4: ['responsibility', 'organization', 'independentWork', 'collaboration', 'initiative', 'selfRegulation', 'strengthsNextStepsLSWH'],
  5: [
    'languagePlan', 'languageResult',
    'frenchPlan', 'frenchResult',
    'nativeLanguage', 'nativeLanguagePlan', 'nativeLanguageResult',
    'mathematicsPlan', 'mathematicsResult',
    'scienceAndTechnologyPlan', 'scienceAndTechnologyResult',
    'socialStudiesPlan', 'socialStudiesResult',
    'healthEducationPlan', 'healthEducationResult',
    'physicalEducationPlan', 'physicalEducationResult',
  ],
  6: [
    'artsHeader',
    'arts1', 'arts1Plan', 'arts1Result',
    'arts2', 'arts2Plan', 'arts2Result',
    'arts3', 'arts3Plan', 'arts3Result',
    'arts4', 'arts4Plan', 'arts4Result',
    'optionalStudies', 'optionalStudiesPlan', 'optionalStudiesResult',
    'strengthsNextStepsSubjects', 'boardInformation2',
  ],
}

export const FIELD_LABELS = {
  date: 'Date',
  studentName: 'Student Name',
  oen: 'OEN',
  daysAbsent: 'Days Absent',
  totalDaysAbsent: 'Total Days Absent',
  grade: 'Grade',
  teacher: 'Teacher',
  timesLate: 'Times Late',
  totalTimesLate: 'Total Times Late',
  board: 'School Board',
  school: 'School',
  address1: 'Address Line 1',
  address2: 'Address Line 2',
  principal: 'Principal',
  telephone: 'Telephone',
  boardInformation1: 'Board Information 1',
  responsibility: 'Responsibility',
  organization: 'Organization',
  independentWork: 'Independent Work',
  collaboration: 'Collaboration',
  initiative: 'Initiative',
  selfRegulation: 'Self-Regulation',
  strengthsNextStepsLSWH: 'Strengths & Next Steps (Learning Skills)',
  languagePlan: 'Language - Plan',
  languageResult: 'Language - Result',
  frenchPlan: 'French - Plan',
  frenchResult: 'French - Result',
  nativeLanguage: 'Native Language',
  nativeLanguagePlan: 'Native Language - Plan',
  nativeLanguageResult: 'Native Language - Result',
  mathematicsPlan: 'Mathematics - Plan',
  mathematicsResult: 'Mathematics - Result',
  scienceAndTechnologyPlan: 'Science & Technology - Plan',
  scienceAndTechnologyResult: 'Science & Technology - Result',
  socialStudiesPlan: 'Social Studies - Plan',
  socialStudiesResult: 'Social Studies - Result',
  healthEducationPlan: 'Health Education - Plan',
  healthEducationResult: 'Health Education - Result',
  physicalEducationPlan: 'Physical Education - Plan',
  physicalEducationResult: 'Physical Education - Result',
  artsHeader: 'Arts Header',
  arts1: 'Arts 1 Name',
  arts1Plan: 'Arts 1 - Plan',
  arts1Result: 'Arts 1 - Result',
  arts2: 'Arts 2 Name',
  arts2Plan: 'Arts 2 - Plan',
  arts2Result: 'Arts 2 - Result',
  arts3: 'Arts 3 Name',
  arts3Plan: 'Arts 3 - Plan',
  arts3Result: 'Arts 3 - Result',
  arts4: 'Arts 4 Name',
  arts4Plan: 'Arts 4 - Plan',
  arts4Result: 'Arts 4 - Result',
  optionalStudies: 'Optional Studies Name',
  optionalStudiesPlan: 'Optional Studies - Plan',
  optionalStudiesResult: 'Optional Studies - Result',
  strengthsNextStepsSubjects: 'Strengths & Next Steps (Subjects)',
  boardInformation2: 'Board Information 2',
}

export const CORE_SUBJECTS = [
  { label: 'Language',             planField: 'languagePlan',             resultField: 'languageResult',             plans: twoPlans },
  { label: 'French',               planField: 'frenchPlan',               resultField: 'frenchResult',               plans: sixPlans },
  { label: 'Native Language',      planField: 'nativeLanguagePlan',       resultField: 'nativeLanguageResult',       plans: twoPlans, nameField: 'nativeLanguage' },
  { label: 'Mathematics',          planField: 'mathematicsPlan',          resultField: 'mathematicsResult',          plans: threePlans },
  { label: 'Science & Technology', planField: 'scienceAndTechnologyPlan', resultField: 'scienceAndTechnologyResult', plans: threePlans },
  { label: 'Social Studies',       planField: 'socialStudiesPlan',        resultField: 'socialStudiesResult',        plans: threePlans },
  { label: 'Health Education',     planField: 'healthEducationPlan',      resultField: 'healthEducationResult',      plans: threePlans },
  { label: 'Physical Education',   planField: 'physicalEducationPlan',    resultField: 'physicalEducationResult',    plans: threePlans },
]

export const ARTS_ROWS = [
  { nameField: 'arts1', planField: 'arts1Plan', resultField: 'arts1Result', placeholder: 'e.g. Visual Arts' },
  { nameField: 'arts2', planField: 'arts2Plan', resultField: 'arts2Result', placeholder: 'e.g. Music' },
  { nameField: 'arts3', planField: 'arts3Plan', resultField: 'arts3Result', placeholder: 'e.g. Drama' },
  { nameField: 'arts4', planField: 'arts4Plan', resultField: 'arts4Result', placeholder: 'e.g. Dance' },
]
